export default "__VITE_ASSET__C0QTG9n1__"